<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row align="center">
      <v-col cols="12" sm="1">
        <v-text-field label="Id" v-model="id" readonly></v-text-field>
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          label="Item"
          v-model="descricao"
          readonly
        ></v-text-field> </v-col
      ><v-col cols="12" sm="1">
        <v-text-field
          label="Cod. Fabricante"
          v-model="codigo"
          readonly
        ></v-text-field> </v-col
      ><v-col cols="12" sm="2">
        <v-text-field
          label="Und."
          v-model="unidadeMedida"
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="1">
        <v-text-field
          v-model="quantidade"
          hide-details
          label="Qtd."
          type="number"
          v-mask="['#####']"
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          label="Observação"
          v-model="observacao" v-uppercase
          maxlength="500"
          counter
        ></v-text-field>
      </v-col>
    </v-row>
    <v-snackbar v-model="errorMessage" color="error" timeout="3000"
      >Informe a quantidade!
    </v-snackbar>
  </v-form>
</template>

<script>
export default {
  name: "editaProdutoRquisicao",
  data: () => ({
    valid: true,
    id: null,
    descricao: null,
    codigo: null,
    unidadeMedida: null,
    quantidade: null,
    observacao: null,
    errorMessage: false,
  }),
  props: {
    isAllowed: Boolean,
  },
  methods: {
    updateObjectEstate() {
      //return this.$refs.form.validate();
      if (this.quantidade > 0) {
        return true;
      } else {
        return false;
      }
      /*if (
        !this.cep ||
        !this.logradouro ||
        !this.numero ||
        !this.bairro ||
        !this.cidade ||
        !this.uf
      ) {
        if (!this.cep) this.errors.push("cep");
        if (!this.logradouro) this.errors.push("logradouro");
        if (!this.bairro) this.errors.push("bairro");
        if (!this.cidade) this.errors.push("cidade");
        if (!this.uf) this.errors.push("uf");
        if (!this.numero) this.errors.push("numero");
        return false;
      } else {
        return true;
      }*/
    },
    updateObject2(produto) {
      this.id = produto.idProduto;
      this.descricao = produto.descricao;
      this.codigo = produto.codigo;
      this.unidadeMedida = produto.unidadeMedida;
      this.quantidade = produto.quantidade;
      this.observacao = produto.observacao;
    },

    clear() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
  },
};
</script>